import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export interface WalletState {
  account?: any;
  status?:
    | "idle"
    | "loading"
    | "connected"
    | "disconnected"
    | "provider_not_available";
  network?: any;
  provider?: any;
  tokenBalances?: Record<string, string>;
  selectedToken?: string;
  preferredChainId?: number;
}

const initialState: WalletState = { status: "idle", preferredChainId: 137 };

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWallet: (state, action: PayloadAction<WalletState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setStatus: (state, action: PayloadAction<WalletState["status"]>) => {
      if (action.payload === "connected")
        return {
          ...state,
          status: action.payload,
        };
      return {
        ...initialState,
        status: action.payload,
      };
    },
    setProvider: (state, action: PayloadAction<WalletState["provider"]>) => {
      return {
        ...state,
        provider: action.payload,
      };
    },
    setNetwork: (state, action: PayloadAction<WalletState["network"]>) => {
      return {
        ...state,
        network: action.payload,
      };
    },
    setTokenBalances: (state, action: PayloadAction<Record<string, string>>) => {
      return {
        ...state,
        tokenBalances: action.payload,
      };
    },
    setSelectedToken: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedToken: action.payload,
      };
    },
    setPreferredChain: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        preferredChainId: action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setWallet, setStatus, setProvider, setNetwork, setTokenBalances, setSelectedToken, setPreferredChain } =
  walletSlice.actions;

export const wallet = (state: RootState) => state.wallet;
export const walletStatus = (state: RootState) => state.wallet.status;
export const walletAddress = (state: RootState) =>
  state.wallet.account?.address;
export const provider = (state: RootState) => state.wallet.provider;
export const walletBalance = (state: RootState) =>
  state.wallet.account?.balance;
export const walletChainId = (state: RootState) =>
  state.wallet.network?.chainId;
export const walletTokenBalances = (state: RootState) =>
  state.wallet.tokenBalances;
export const walletSelectedToken = (state: RootState) =>
  state.wallet.selectedToken;
export const walletPreferredChainId = (state: RootState) =>
  state.wallet.preferredChainId;

export default walletSlice.reducer;
